import './Footer.css'
import { BsLinkedin, BsTwitter } from 'react-icons/bs'


const Footer = () => {

  return (
    
    <footer>
      <a href='#' className='footer__logo'>DANNY<span className='Heart__eyeEmoji'>😍</span></a>

      <ul className='permalinks'>

        <li><a href='#'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#experience'>Experience</a></li>
        <li><a href='#portfolio'>Portfolio</a></li>
        <li><a href='#contact'>Contact</a></li>


      </ul>

      <div className='footer__socials'>

        <a href='https://twitter.com/@daniel17_ik'><BsTwitter /></a>
        <a href='https://www.linkedin.com/in/daniel-ikechukwu-122000217/'><BsLinkedin /></a>
         
      </div>
    </footer>
  )
}

export default Footer